import React from 'react';

/**
 * EL NOMBRE Y LA ETIQUETA «PROMO» EN LA MISMA LÍNEA (Jesús, 27-09 22:46, con la captura del
 * post: en «Aislado de suero - Whey Isolate (FullGas)» la etiqueta caía sola a la línea de abajo).
 * La última palabra del nombre y la etiqueta van juntas y sin partir: si no caben, bajan las
 * dos, y la etiqueta nunca se queda sola en otra línea.
 *
 * «PROMO» Y CON REBORDE NARANJA (Jesús, 27-09 22:15: «Promocionado tiene que salir promo, un
 * reborde en color naranja y la misma línea... yo lo pondría promo así como al lado en
 * pequeño»). Antes era «PROMOCIONADO» en blanco sobre negro.
 */
export default function NombreConEtiqueta({ nombre, promocionado }) {
    const texto = String(nombre || '');
    if (!promocionado) return <>{texto}</>;
    const corte = texto.trimEnd().lastIndexOf(' ');
    const cabeza = corte >= 0 ? texto.slice(0, corte + 1) : '';
    const cola = corte >= 0 ? texto.slice(corte + 1) : texto;
    return (
        <>
            {cabeza}
            <span className="whitespace-nowrap">
                {cola}
                <span className="ml-1.5 align-middle inline-block text-[9px] leading-none font-bold tracking-wide text-brand border border-brand rounded px-1 py-0.5"
                    data-testid="etiqueta-promo">PROMO</span>
            </span>
        </>
    );
}
